import React, { FC } from 'react';

import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';

import { FormFieldWrapper } from 'components/shared/BaseFormComponents';
import { getDateByDayNumber } from 'components/shared/DatePicker/DayPicker/functions';
import { parseDate } from 'components/shared/DatePicker/functions';
import { InputDatePicker, InputDayPicker } from 'components/shared/HookFormComponents/datePicker/inputs';
import { EOrganizedBy, ETripEvent, ITripEvent } from 'detailsv2/structure';
import { itineraryScheduleTypeSelector } from 'store/itinerariesItem/selectors';

import cs from '../../index.module.css';
import { DatePickerFormValues, IDaysOrDateTransfer } from './types';

export const DayOrDatePicker: FC<IDaysOrDateTransfer> = ({ isStartDate = false }) => {
  const { control, watch } = useFormContext<DatePickerFormValues>();
  const scheduleType = useSelector(itineraryScheduleTypeSelector);
  const isOrganizeByDate = scheduleType === EOrganizedBy.Date;

  const startDate = watch('datesRange.start');
  const startDay = watch('daysRange.start');

  const arrivalParseDate = parseDate(startDate);
  const arrivalParseDay = getDateByDayNumber(startDay);

  return (
    <>
      {isOrganizeByDate ? (
        <>
          {isStartDate ? (
            <Controller<Partial<ITripEvent<ETripEvent.Transfer>>, 'datesRange.start'>
              name="datesRange.start"
              control={control}
              render={(fieldProps) => {
                const errorMessage = fieldProps.fieldState.error?.message;
                return (
                  <div className={cs.pickerWrapper}>
                    <FormFieldWrapper errorMessage={errorMessage}>
                      <InputDatePicker placeholder="Date*" mode="single" position="BOTTOM_LEFT" {...fieldProps} />
                    </FormFieldWrapper>
                  </div>
                );
              }}
            />
          ) : (
            <Controller<Partial<ITripEvent<ETripEvent.Transfer>>, 'datesRange.end'>
              name="datesRange.end"
              control={control}
              render={(fieldProps) => {
                const errorMessage = fieldProps.fieldState.error?.message;
                return (
                  <div className={cs.pickerWrapper}>
                    <FormFieldWrapper errorMessage={errorMessage}>
                      <InputDatePicker
                        placeholder="Date*"
                        mode="single"
                        position="BOTTOM_LEFT"
                        defaultMonth={arrivalParseDate}
                        modifiers={{ arrivalDate: arrivalParseDate }}
                        modifiersClassNames={{ arrivalDate: cs.arrivalDate }}
                        {...fieldProps}
                      />
                    </FormFieldWrapper>
                  </div>
                );
              }}
            />
          )}
        </>
      ) : (
        <>
          {isStartDate ? (
            <Controller<Partial<ITripEvent<ETripEvent.Transfer>>, 'daysRange.start'>
              name="daysRange.start"
              control={control}
              render={(fieldProps) => {
                const errorMessage = fieldProps.fieldState.error?.message;
                return (
                  <div className={cs.pickerWrapper}>
                    <FormFieldWrapper errorMessage={errorMessage}>
                      <InputDayPicker placeholder="Day*" mode="single" position="BOTTOM_LEFT" {...fieldProps} />
                    </FormFieldWrapper>
                  </div>
                );
              }}
            />
          ) : (
            <Controller<Partial<ITripEvent<ETripEvent.Transfer>>, 'daysRange.end'>
              name="daysRange.end"
              control={control}
              render={(fieldProps) => {
                const errorMessage = fieldProps.fieldState.error?.message;
                return (
                  <div className={cs.pickerWrapper}>
                    <FormFieldWrapper errorMessage={errorMessage}>
                      <InputDayPicker
                        placeholder="Day*"
                        mode="single"
                        position="BOTTOM_LEFT"
                        defaultMonth={arrivalParseDay}
                        modifiers={{ arrivalDate: arrivalParseDay }}
                        modifiersClassNames={{ arrivalDate: cs.arrivalDate }}
                        {...fieldProps}
                      />
                    </FormFieldWrapper>
                  </div>
                );
              }}
            />
          )}
        </>
      )}
    </>
  );
};
